import moment from 'moment';

import { getQTDIntervals, getYTDIntervals } from '../../utils/intervalpicker-utils';
import {
    PREVIOUS_7_DAYS,
    PREVIOUS_30_DAYS,
    PREVIOUS_MONTH,
    PREVIOUS_QUARTER,
    PREVIOUS_YEAR,
    QUARTER_TO_DATE,
    YEAR_TO_DATE
} from './definitions';

export const intervalMap = {
    [PREVIOUS_30_DAYS]: ['day', 'week'],
    [PREVIOUS_MONTH]: ['day','week'],
    [PREVIOUS_QUARTER]: ['week', 'month'],
    [PREVIOUS_YEAR]: ['month','quarter'],
    [QUARTER_TO_DATE]: getQTDIntervals(),
    [YEAR_TO_DATE]: getYTDIntervals()
};

export const dateOptionMap = {
    [PREVIOUS_7_DAYS]: {
        diff: 7,
        display: 'Last 7 Days',
        end: moment().utc().subtract( 1, 'days' ).format( 'YYYY-MM-DD' ),
        key: PREVIOUS_7_DAYS,
        start: moment().utc().subtract( 7, 'days' ).format( 'YYYY-MM-DD' ),
    },
    [PREVIOUS_30_DAYS]: {
        diff: 30,
        display: 'Last 30 Days',
        end: moment().utc().subtract( 1, 'days' ).format( 'YYYY-MM-DD' ),
        key: PREVIOUS_30_DAYS,
        start: moment().utc().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
    },
    [PREVIOUS_MONTH]: {
        display: 'Previous Month',
        end: moment().subtract( 1, 'days' ).subtract( 1, 'month' ).endOf( 'month' ).format( 'YYYY-MM-DD' ),
        key: PREVIOUS_MONTH,
        start: moment().subtract( 1, 'days' ).subtract( 1, 'month' ).startOf( 'month' ).format( 'YYYY-MM-DD' ),
    },
    [PREVIOUS_QUARTER]: {
        display: 'Previous Quarter',
        end: moment().utc().subtract( 1, 'days' ).subtract( 1, 'quarter' ).endOf( 'quarter' ).format( 'YYYY-MM-DD' ),
        key: PREVIOUS_QUARTER,
        start: moment().utc().subtract( 1, 'days' ).subtract( 1, 'quarter' ).startOf( 'quarter' ).format( 'YYYY-MM-DD' ),
    },
    [PREVIOUS_YEAR]: {
        display: 'Previous Year',
        end: moment().utc().subtract( 1, 'days' ).subtract( 1, 'year' ).endOf( 'year' ).format( 'YYYY-MM-DD' ),
        key: PREVIOUS_YEAR,
        start: moment().utc().subtract( 1, 'days' ).subtract( 1, 'year' ).startOf( 'year' ).format( 'YYYY-MM-DD' ),
    },
    [QUARTER_TO_DATE]: {
        display: 'Quarter to Date',
        end: moment().utc().format( 'YYYY-MM-DD' ),
        key: QUARTER_TO_DATE,
        start: moment().utc().subtract( 1, 'days' ).startOf( 'quarter' ).format( 'YYYY-MM-DD' ),
    } ,
    [YEAR_TO_DATE]: {
        display: 'Year to Date',
        end: moment().utc().format( 'YYYY-MM-DD' ),
        key: YEAR_TO_DATE,
        start: moment().utc().subtract( 1, 'days' ).startOf( 'year' ).format( 'YYYY-MM-DD' ),
    }
};
